import { AnnotationToolLayoutProps } from 'packages/at-shell/components/app-shell/app-layout';
import { PolarisRoot } from 'packages/polaris/tool/root';
import { PolarisTopUI } from 'packages/polaris/tool/top-ui';
import { PolarisSider } from 'packages/polaris/portal/sider';

export default {
  theme: 'dark',
  sceneActions: <PolarisTopUI />,
  primaryView: <PolarisRoot />,
  sider: null,
  siderFooterActions: null,
  toolbar: <PolarisSider />,
  config: {
    toolbarProps: {
      width: 200,
    },
  },
  effects: undefined,
} as AnnotationToolLayoutProps;
